<template>
  <v-container fluid pa-5 class="mt-10">
    <v-row justify="center">
      <v-col cols="12" xs="12" sm="8" md="6" lg="4">
        <v-card class="elevation-12 pa-2" style="border-radius: 12px;">
          <div class="d-flex justify-center">
            <v-img class="ma-3" contain :src="logo"  max-width="300"></v-img>
          </div>
          <v-card-text>
            <slot name="form"></slot>
          </v-card-text>
          <v-col cols="12">
            <slot name="control"></slot>
          </v-col>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { useFavicon } from '@vueuse/core'
const icon = useFavicon()
icon.value =  process.env.VUE_APP_API_ROOT + '/company_settings/favicon' // change current icon

export default {

  props: {
    title: {
      default: "Login",
      type: String
    }
  },
  data() {
    return {
      favicon: process.env.VUE_APP_API_ROOT + '/company_settings/favicon',
      url_defaults: [
        'app.checkbits.com.br',
        'localhost',
        'stg.checkbits.com.br'
      ]
    };
  },
  computed: {
    is_checkbits() {
      const current_url = window.location.hostname;

      if (this.url_defaults.includes(current_url)) 
        return true;
      
      return false;
    },
    logo() {
      const is_dark_mode = localStorage.getItem("is_dark_mode");
      console.log("is_dark_mode", is_dark_mode);
      if (is_dark_mode == 'true' && !this.is_checkbits) {
        return process.env.VUE_APP_API_ROOT + `/company_settings/logo_dark`;
      } else {
        return process.env.VUE_APP_API_ROOT + `/company_settings/logo`;
      }
    }
  },
};
</script>
